(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* Antes de enviar el formulario, ponemos la variante de la talla pulsada y quitamos el foco */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-card__size-button');
    if (!button) return;
    
    const input = button.closest('form')?.querySelector('input[name="id"]');
    if (input) input.value = button.dataset.variantId;
    
    // Quitamos el foco del botón para que no se quede bloqueada la barra desplegada
    button.blur();
  });
  } catch(e) { console.error(e); }
})();

})();
